<template>
<div v-if="isLoaded">
    <div v-if="provider !== 'error'">
        <h1> {{ provider.provider_type.id === 1 ? $t('distributorsView') : $t('suppliersView')  }} </h1>
        <el-button 
            style="float: right; font-size: 20px" 
            icon="el-icon-edit"
            type="primary" 
            @click="$router.push({name: 'ProviderEdit', params: {provider: provider, isEdit: true}})"
            />

        <el-card>
            <table>
                <tr>
                    <td class="res-name"> {{ $t('providerDisplayName') }} </td>
                    <td class="">
                        <lang-tabs-view :input="provider.display_name"/>
                    </td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerLegalName') }} </td>
                    <td class=""> {{ provider.legal_name }} </td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerProviderType') }} </td>
                    <td class="">{{provider.provider_type ? provider.provider_type.type_name : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerLogo') }} </td>
                    <td class="res-value"><img @error="provider.logo = ''" :src="url + provider.logo+ '?q='+ timestamp"></td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerCity') }} </td>
                    <td class="">{{provider.city ? provider.city : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerZip') }} </td>
                    <td class="">{{provider.zip ? provider.zip : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerAddress') }} </td>
                    <td class="">{{provider.address ? provider.address : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerPhone') }} </td>
                    <td class="">{{provider.phone ? provider.phone : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerEmail') }} </td>
                    <td class="">{{provider.email ? provider.email : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerWeb') }} </td>
                    <td class="">{{provider.web ? provider.web : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerUser') }} </td>
                    <td class="" @click="$router.push({name: 'SingleUser', params: {id: provider.user.id}})">
                        {{provider.user ? provider.user : '/'}}
                    </td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerDescription') }} </td>
                    <td class="">
                        <lang-tabs-view :input="provider.description ? provider.description : {}"/>
                    </td>
                </tr>
                <!-- <tr>
                    <td class="res-name"> {{ $t('providerCreatedAt') }} </td>
                    <td class="">{{provider.created_at ? provider.created_at : '/'}}</td>
                </tr>
                <tr>
                    <td class="res-name"> {{ $t('providerUpdatedAt') }} </td>
                    <td class="">{{provider.updated_at ? provider.updated_at : '/'}}</td>
                </tr> -->
            </table> 
        </el-card>
        <br>
        <rates :providerType="provider.provider_type.type_name"/>

        <!-- <view-shared-buttons redirectPath="Providers"/> -->

    </div>
    <div v-else>
        <not-found/>
    </div>
</div>
</template>

<script>
import {ImageUrl} from '@/main'
import {mapGetters} from 'vuex'
import api from '@/api/api'
import LayoutHeaders from '../LayoutPart/LayoutHeaders'
import LangTabsView from '../LangTabs/LangTabsView'
import ViewSharedButtons from '../Shared/ViewSharedButtons'
import NotFound from '../NotFound'
import Rates from '../Rates/Rates'

export default {
    components: {
        LayoutHeaders,
        LangTabsView,
        ViewSharedButtons,
        NotFound,
        Rates
    },
    data () {
        return {
            emptyText: '',
            isLoaded: false,
            provider: {},
            selectedRates: [],
            url: ImageUrl
        }
    },
    computed: {
        ...mapGetters({
            providerRates: 'getRates'
        }),
        timestamp() {
            return Date.now();
        }
},
    async created () {
        let provider
        await api.fetchSingleProvider(this.$route.params.id)
        .then((res) => {
            provider = res.data.data
        })
        .catch((err) => 
            provider = 'error'
        )                
        this.$store.dispatch('fetchProviderRates', this.$route.params.id) 
        this.isLoaded = true

        this.provider = provider
    },
    methods: {
        headerCellStyle({row, column, rowIndex, columnIndex}) {
                return {
                    wordBreak: `normal`,
                    textAlign: `center`,
                    wordWrap: `normal`
                }
            },
            handleSelectionChange (data) {
                this.selectedRates = []
                for (let item of data) {
                    this.selectedRates.push(item.id)
                }   
            }
    }

    
}
</script>

<style scoped>

h1 {
    color: grey;
    font-weight: 500;
    margin-left: 5px;
    display: inline-block;
}

table {
    width: 100%;
}

table > tr > td{
    padding: 20px !important;
    border-bottom: 1px solid #e6e6e6;
    
}

table > tr:last-child > td {
    border: none;
}

table > tr > td:nth-child(2) {
    position: relative;
    margin-left: -3px;
    display: block;
    margin-top: 1px;
}

.res-value-clickable {
    color: #409EFF !important;
    cursor: pointer;
}

.res-name {
    width: 200px;
    color: grey;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
}

.green-box {
    width: 20px;
    height: 20px;
    background: green;
    display: block;
    margin: 0 auto;
}

.red-box {
    width: 20px;
    height: 20px;
    background: red;
    display: block;
    margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Providers/ProviderView.vue